import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./Button.module.css";

export default class Button extends Component {
  render() {
    const { children, className, onClick, color, type } = this.props;
    const colorStyle = styles[color] || styles.primary;
    const typeStyle = styles[type] || "";
    const classOverride = className || "";

    return (
      <button
        {...this.props}
        className={
          styles.button +
          " " +
          colorStyle +
          " " +
          typeStyle +
          " " +
          classOverride
        }
        onClick={onClick}
      >
        {children}
      </button>
    );
  }
}

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
  type: PropTypes.string,
};
